import { Text } from "@mantine/core"

import { DEFAULT_DATE_FORMAT } from "@costory/shared/const"
import dayjs from "@costory/shared/dayjs"

export function DateCell({ date }: { date: Date }) {
  return <Text size="sm"> {dayjs(date).format(DEFAULT_DATE_FORMAT)} </Text>
}
